import { Injectable } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ExamsByCode } from './ExamsByCode.class';

@Injectable({
  providedIn: 'root',
} )
export class ExamsConfigService {
  examsByCode = new ExamsByCode();
  constructor(public formBuilder: FormBuilder) { }

  getConfig( codigoExamen: string ): any {
    return new this.examsByCode.data[codigoExamen].controller(this.formBuilder);
  }

  getExamenCodeTypeId( codigoExamen: string ): any {
    return this.examsByCode.data[codigoExamen].id;
  }
}
